import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  uinfo: {},
  deptStationUserList: [],
  allUserUnip: []
}

const getters = {
  deptStationUserList: (state) => {
    return state.deptStationUserList
  },
  uinfo: (state) => {
    return state.uinfo
  }
}
const mutations = {
  setUinfo: (state, uinfo) => {
    console.log('uinfo', uinfo)
    state.uinfo = uinfo
  },
  setAllUserUnip(state, data) {
    state.allUserUnip = data
  },
  setDeptStationUserList(state, data) {
    state.deptStationUserList = data
  },
}

const plugins = [
  createPersistedState({
    key: 'storedata',
    storage: {
      getItem: (key) => {
        return localStorage.getItem(key)
      },
      setItem: (key, value) => {
        return localStorage.setItem(key, value)
      },
      removeItem: (key) => localStorage.removeItem(key),
    },
  })
];

export default new Vuex.Store({
  state,
  getters,
  mutations,
  plugins
})



// WEBPACK FOOTER //
// ./src/vuex/store.js